/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import {useDispatch} from "react-redux"; // Import hooks to dispatch actions and access Redux store
import {useTranslation} from "react-i18next"; // Import hook for internationalization (translations)
import {AssignCardToUser, GetAllCardFormats} from "../../../reduxToolkit/Cards/CardsApi"; // Import actions to assign cards and get card formats
import {useEffect, useState} from "react";
import {toast} from "react-toastify"; // Import React hooks for managing side effects and state

// Main component for creating a template, assigning cards to employees, and handling form submissions
const CreateTemplateApp = ({ onHide, cardToAssign, setModified }) => {
    const { t } = useTranslation(); // Initialize translation function
    const dispatch = useDispatch(); // Redux dispatch function to trigger actions
    const [emptyFields, setEmptyFields] = useState(false); // State to track if any required fields are empty
    const [selectedList, setSelectedList] = useState([]); // State to store the employee ID input value

    // useEffect hook to run side effects when the component is mounted
    useEffect(() => {
        setSelectedList([]); // Reset the employee field
        dispatch(GetAllCardFormats()); // Dispatch action to get all available card formats
        setEmptyFields(false); // Reset emptyFields state
    }, []); // Empty dependency array means this effect will run only once when the component is mounted

    // Function to handle confirming the assignment of the card to the selected employee
    const handleConfirm = () => {
        setEmptyFields(true); // Set emptyFields to true initially
        if (selectedList?.length > 0) { // Check if the employee field is filled
            setEmptyFields(false); // If employee is selected, set emptyFields to false
            const data = {
                cardIds: [cardToAssign.id], // Prepare data with the card to be assigned
                userId: selectedList[0].id, // Add selected employee's ID
            };
            // Dispatch action to assign the card to the selected employee
            dispatch(AssignCardToUser(data)).then(
                ({payload: {data: { success }}}) => {
                    if (success === true) { // If the card assignment is successful
                        onHide(); // Hide the modal
                        setModified(true); // Set modified state to true
                        toast.success(t('has_been_assigned_successfully'));
                    }
                },
            );
        }
    };

    // Return the necessary values and functions for the component to use
    return {
        t,
        selectedList, // Employee input value
        setSelectedList,
        emptyFields,
        handleConfirm
    }
}

export default CreateTemplateApp; // Export the component for use in other parts of the app

